var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteDisabledFill = function SvgFavoriteDisabledFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D8E2",
    stroke: "#D1D8E2",
    strokeLinejoin: "round",
    d: "M9.663 3.81a.375.375 0 0 1 .674 0l1.782 3.611c.055.111.16.188.283.206l3.986.579c.308.045.431.423.208.64l-2.884 2.812a.375.375 0 0 0-.108.332l.68 3.97a.375.375 0 0 1-.544.396l-3.565-1.874a.375.375 0 0 0-.35 0L6.26 16.356a.375.375 0 0 1-.545-.396l.681-3.97a.375.375 0 0 0-.108-.332L3.404 8.846a.375.375 0 0 1 .208-.64l3.986-.58a.375.375 0 0 0 .283-.205L9.663 3.81Z"
  })));
};
export default SvgFavoriteDisabledFill;